import { Mark, mergeAttributes, Extension } from "@tiptap/core";
import { Plugin } from "@tiptap/pm/state";

export const CommentMark = Mark.create({
  name: "commentMark",

  addAttributes() {
    return {
      commentId: null,
    };
  },

  parseHTML() {
    return [{ tag: "span[data-comment-id]" }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "span",
      mergeAttributes(HTMLAttributes, {
        "data-comment-id": HTMLAttributes.commentId,
        class: "comment-highlight",
      }),
      0,
    ];
  },
});

export const CommentExtension = Extension.create({
  name: "commentExtension",

  addCommands() {
    return {
      addComment:
        () =>
        ({ state, dispatch, editor }) => {
          const { from, to } = state.selection;
          if (from === to) return false;

          const id = crypto.randomUUID();

          editor.chain().setMark("commentMark", { commentId: id }).run();

          editor.storage.comments = editor.storage.comments || [];
          editor.storage.comments.push({
            id,
            from,
            to,
          });

          return true;
        },
    };
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          handleClick(view, pos) {
            const { doc } = view.state;

            let found = null;

            doc.nodesBetween(pos, pos, (node) => {
              node.marks?.forEach((mark) => {
                if (mark.type.name === "commentMark") {
                  found = mark.attrs.commentId;
                }
              });
            });

            if (found) {
              window.dispatchEvent(
                new CustomEvent("comment:focus", {
                  detail: { id: found },
                }),
              );
            }

            return false;
          },
        },
      }),
    ];
  },
});
